/**
 * 需求来源：MCP/chatgptMCP_version2.html
 * 注意事项：
 * 1. /ai/chatgpt 为纯展示型 SSR 营销落地页，仅返回 SEO 和 CDN_HOST。
 * 2. 本文件同时运行在 Node 与浏览器打包环境，使用 CommonJS，禁止 import/export 与 fs/path。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @param {Function} request - 统一请求函数（本页面未使用）
 * @returns {Object} 页面初始化数据，包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  // 获取 Egg.js 原始上下文：SSR 框架直传原始 ctx（ctx.app 存在）或统一上下文包装（ctx.ctx）
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  // CSR fallback: 从 layout 模板注入的全局变量获取
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost: cdnHost,
    __seo: {
      title: 'CJ MCP - Manage Your Dropshipping Business with AI',
      keywords:
        'CJ MCP, ChatGPT dropshipping, CJdropshipping MCP, AI dropshipping assistant, MCP integration',
      description:
        'Connect ChatGPT, Claude and Codex to CJdropshipping via MCP. Search products, place orders, track shipments and manage your dropshipping business through AI conversation.',
    },
  };
}

module.exports = fetchData;
